module.exports = __webpack_public_path__ + "static/media/feature-mobile-profile@3x.3017651a.png";